import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataService } from 'src/app/modules/global/services/data.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: true,
  imports: [MatProgressSpinnerModule]
})
export class LoadingComponent {

  loading = false;
  active = false;
  excludeUrls: string[] = [
    'dashboard/coupons', 'dashboard/card/movements'
  ];

  constructor(
    private data: DataService,
    private router: Router
  ) {
    this.data.getIsLoading().subscribe((isLoad) => {
      this.loading = isLoad;
    });

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.activateLoading(e as NavigationEnd);
    });
  }

  activateLoading(e: NavigationEnd) {
    this.active = this.excludeUrls.every(url => !e.urlAfterRedirects.includes(url));
  }

}
